import { Col, Row } from "antd";

import { CustomExpiryOptions } from "./CustomExpiryOptions";
import { MaxAccessDuration } from "./MaxAccessDuration";
import { MaxApprovalDuration } from "./MaxApprovalDuration.tsx";
import { StandingAccessDuration } from "./StandingAccessDuration";

export const ApprovalRequirements: React.FC = () => {
  return (
    <Row gutter={[0, 32]}>
      <Col span={24}>
        <CustomExpiryOptions />
      </Col>
      <Col span={24}>
        <MaxApprovalDuration />
      </Col>
      <Col span={24}>
        <MaxAccessDuration />
      </Col>
      <Col span={24}>
        <StandingAccessDuration />
      </Col>
    </Row>
  );
};
